import type { CoreApiClient } from "../client";
import { createMeterQueries } from "../queries/meter.queries";

export const createMeterRepository = (api: CoreApiClient) => ({
  ...createMeterQueries(api),
});
